// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"69de4c5d","455":"a897dabb","946":"f9efe3d8"}[chunkId] + ".chunk.js";
};